module.exports = __webpack_public_path__ + "img/heart_with_arrow.6c29ed63.gif";